import React, { Component, PropType } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { removeFilter, set_property_metric_breakup, remove_property_metric_breakup, get_property_metric_breakup, set_disp_objects, setTableActions, handle_transpose_table, toggleOldFilter } from '../../actions/index'
import CalenderComponent from './CalenderComponent.js';

var textMarginTop = { marginTop: '10px' };
var textMarginBottom = { marginTop: '-6px' };
var toolTipCSS = { display: 'inline-block ! important', color: 'black ! important', padding: '0px', paddingLeft: '5px', cursor: 'auto' };
var $SelectedBreakUpDisp = null, $propertyDisp = null, $handleChange = null, $metricFunction = {}, $filterHandleChange = null, $current_page = null, $includeDisp = null, $excludeDisp = null;
var selectedMetricDisp;
var selectedMetricWithRangeGlobel = [], chartToSwitch = [];

var metricMulti = false, propMulti = false;

class FilterComponent extends React.Component {
    constructor(props) {
        super(props);
        var pageName = window.location.pathname.split('/');
        pageName = pageName[1];
        if (dataLabels != '1') {
            this.state = {
                dataLabelsButton: "Add Data Labels",
                insightEnable: false,
                property_multi: false,
                crosstab_flag: false,
                metric_multi: false,
                pageName: pageName
            }
        } else {
            this.state = {
                dataLabelsButton: "Remove Data Labels",
                insightEnable: false,
                property_multi: false,
                crosstab_flag: false,
                metric_multi: false,
                pageName: pageName
            }
        }
        this.metricContext = this.metricContext.bind(this);
        this.replaceWordWithFunction = this.replaceWordWithFunction.bind(this);
        this.changeDispObject = this.changeDispObject.bind(this);
        this.oldFilterToggle = this.oldFilterToggle.bind(this);
    }
    componentDidMount() {
        $metricFunction = this.props.metricFunction;
        selectedMetricDisp = this.props.selectedMetricDisp;
        jQuery('[data-toggle="tooltip"]').tooltip();
        this.filterValuesToShow(this.props);
        $propertyDisp = this.props.propertyDisp;
        this.tagsDefining();
    }
    componentWillReceiveProps(nextProps) {
        $SelectedBreakUpDisp = nextProps.SelectedBreakUpDisp;
        $propertyDisp = nextProps.propertyDisp;
        selectedMetricDisp = nextProps.selectedMetricDisp;
        this.metricContext($metricFunction, $handleChange);
        if (dataLabels != '1')
            var dataLabelsButton = "Add Data Labels";
        else var dataLabelsButton = "Remove Data Labels";
        this.setState({ dataLabelsButton: dataLabelsButton, pageName: nextProps.pageName, dashboardConfigDates: nextProps.dashboardConfigDates });
        this.filterValuesToShow(nextProps, this.props);
    }
    metricContext(metricFunction, handleChange) {
        
        var $temp_metricFunction = {};
        var that = this;
        metricFunction=Object.values(metricFunction);
        if (metricFunction) {
            metricFunction.map(function (innerData) {
                if (innerData.value) {

                    if ($temp_metricFunction[innerData.metricGroup])
                        $temp_metricFunction[innerData.metricGroup]['items'][innerData.value] = innerData;
                    else {
                        $temp_metricFunction[innerData.metricGroup] = { "name": innerData.metricGroup, "items": {} };
                        $temp_metricFunction[innerData.metricGroup]['items'][innerData.value] = innerData;
                    }
                    // $temp_metricFunction[innerData.value] = innerData
                }
            })

            if ($temp_metricFunction) {
                jQuery(function () {
                    jQuery.contextMenu({
                        selector: '.contextAllow',
                        callback: function (key, options) {
                            key = options.commands[key].value;
                            // key = $temp_metricFunction[key].value;
                            that.replaceWordWithFunction(this[0].innerText, key, selectedMetricDisp, $handleChange);
                            // var m = "clicked: " + key;
                            // window.console && console.log(m) || alert(m);
                        },
                        items: $temp_metricFunction
                    });
                    if ($temp_metricFunction.percentile) {
                        jQuery.contextMenu({
                            selector: '.noContext',
                            callback: function (key, options) {
                                key = options.commands[key].value;
                                // key = $temp_metricFunction[key].value;
                                that.replaceWordWithFunction(this[0].innerText, key, selectedMetricDisp, $handleChange);
                                // var m = "clicked: " + key;
                                // window.console && console.log(m) || alert(m);
                            },
                            items: { "": { "name": "Default", "value": "" }, "percentile": { "name": "Percentile", "value": "percentile" } }
                        });
                    }
                });
            }
        }
    }
    replaceWordWithFunction(text, functionName, selectedMetricDisp, $handleChange) {
        $handleChange = this.state.pageName == "dashboard" ? this.props.propertyHandle : this.props.handleChange;
        var finalFunction = null;
        var that = this;
        metricFunction.map(function (innerData) {
            if (innerData.value === functionName) {
                finalFunction = innerData;
            }
        })

        var finalMetricArray = JSON.parse(JSON.stringify(selectedMetricDisp));
        selectedMetricDisp.map(function (innerData) {

            if (innerData.label === text) {
                that.changeDispObject(innerData, metricFunction, finalFunction);
                finalMetricArray.push(innerData);
            }
        })
        this.props.filterHandleChange({ "selectedMetric": finalMetricArray.map(a => a.value).toString(), "property": this.props.property, "breakup": this.props.breakup, "period": this.state.period, clicked: 'metric' })
        // $handleChange('metric', finalMetricArray);
    }
    changeDispObject(rightClickMetric, functionsArray, metricToReplace) {
        var $done = false;

        if (rightClickMetric.isDerived == 2 && rightClickMetric.defaultFormula == "") {
            rightClickMetric.label = `${metricToReplace.name} ${rightClickMetric.label}`;
            rightClickMetric.value = `${rightClickMetric.value}${metricToReplace.value}`;
        }
        else {
            functionsArray.map(function (innerData) {
                if (innerData.value && !$done) {
                    if (rightClickMetric.value.search('\\b' + innerData.value + '\\b') > -1) {
                        if (rightClickMetric.defaultFormula == metricToReplace.value)
                            rightClickMetric.label = (rightClickMetric.label.replace(innerData.name, "")).trim();
                        else if (innerData.value == rightClickMetric.defaultFormula)
                            rightClickMetric.label = (metricToReplace.name + " " + rightClickMetric.label).trim();
                        else rightClickMetric.label = rightClickMetric.label.replace(innerData.name, metricToReplace.name);
                        rightClickMetric.value = rightClickMetric.value.replace(new RegExp("\\b" + innerData.value + "\\b"), metricToReplace.value);
                        $done = true;
                    }
                } else if (metricToReplace.name == "Percentile" && !$done) {
                    if (rightClickMetric.value[rightClickMetric.value.length - 1] == ';') {
                        rightClickMetric.label = metricToReplace.name + " " + rightClickMetric.label;
                        rightClickMetric.value = rightClickMetric.value + "" + metricToReplace.value;
                        $done = true;
                    }
                }
            })
        }
        return rightClickMetric;
    }
    tagsDefining() {
        var that = this;
        $SelectedBreakUpDisp = this.props.SelectedBreakUpDisp;
        $includeDisp = this.props.includeDisp;
        $excludeDisp = this.props.excludeDisp;
        // Anurag Update on Total dimension
        // Below line commented by Anurag to handle Total Dimension
        // $propertyDisp = this.props.propertyDisp;
        selectedMetricDisp = selectedMetricDisp ? selectedMetricDisp : this.props.selectedMetricDisp;
        $current_page = this.state.pageName;
        $handleChange = this.state.pageName == "dashboard" ? this.props.propertyHandle : this.props.handleChange;
        $filterHandleChange = this.state.pageName == "dashboard" ? this.props.filterHandle : this.props.handleChange;
        var $filterHandleChange = that.props.filterHandleChange;
        this.metricContext($metricFunction, $handleChange);
        var elt = jQuery('#property-taginput');//property jquery multi tag initialize
        elt.tagsinput({
            itemValue: 'value',
            itemText: 'label'
        });//defining which object to be shown and taken as value
        var eltFilter = jQuery('#filter-taginput');//filter jquery multi tag initialize
        eltFilter.tagsinput({
            itemValue: 'value',
            itemText: 'label'
        });
        var eltExclude = jQuery('#exclude-taginput');//exlude jquery multi tag initialize
        eltExclude.tagsinput({
            itemValue: 'value',
            itemText: 'label'
        });
        var eltInclude = jQuery('#include-taginput');//include jquery multi tag initialize
        eltInclude.tagsinput({
            itemValue: 'value',
            itemText: 'label'
        });
        var eltMetric = jQuery('#metric-taginput');//filter jquery multi tag initialize
        eltMetric.tagsinput({
            itemValue: 'value',
            itemText: 'label',
            tagClass: function (item) {
                return 'label label-info contextAllow';
                // return (item.isDerived !== '2' ? 'label label-info contextAllow' : 'label label-info noContext');
            }
        });
        jQuery('#property-taginput').on('itemRemoved', function (event) {
            var getIndex = -1;//getIndex of object
            if ($propertyDisp) {
                if (!$propertyDisp.length) {//if object then convert into array
                    $propertyDisp = [$propertyDisp];
                }
                $propertyDisp.map(function (innerData, index) {//loop the array to find index
                    if (event.item.value == innerData.value) {
                        getIndex = index;
                    }
                });
            }
            if (getIndex >= 0) {
                $propertyDisp.splice(getIndex, 1);//splice the array to remove the object
                if ($propertyDisp.length == 0) {//if there is no property then send null
                    $propertyDisp = null;
                }
                // var temp_metric = selectedMetricDisp.map(a => a.value).toString();
                var temp_property = $propertyDisp ? $propertyDisp.map(a => a.value).toString() : "";
                // var temp_breakup = $SelectedBreakUpDisp.map(a => a.value).toString();
                temp_property = temp_property ? temp_property : "empty";
                $filterHandleChange({ "property": temp_property, clicked: 'property' })//pass to the final function
                // if ($current_page == "dashboard")
                //     $handleChange($propertyDisp);
                // else $handleChange('property', $propertyDisp);//pass to the final function
                that.refs.propertyFilter.loadOptions("");
            }
        });
        jQuery('#filter-taginput').on('itemRemoved', function (event) {
            var getIndex = -1;//getIndex of object
            $SelectedBreakUpDisp.map(function (innerData, index) {//loop the array to find index
                if (event.item.value == innerData.value) {
                    getIndex = index;
                }
            });
            if (getIndex >= 0) {
                $SelectedBreakUpDisp.splice(getIndex, 1);//splice the array to remove the object

                var temp_metric = selectedMetricDisp.map(a => a.value).toString();
                var temp_property = $propertyDisp.map(a => a.value).toString();
                var temp_breakup = $SelectedBreakUpDisp.map(a => a.value).toString();
                temp_breakup = temp_breakup ? temp_breakup : "empty";
                $filterHandleChange({ "breakup": temp_breakup, clicked: 'filter' })//pass to the final function
            }
        });
        jQuery('#exclude-taginput').on('itemRemoved', function (event) {
            var getIndex = -1;//getIndex of object
            $excludeDisp.map(function (innerData, index) {//loop the array to find index
                if (event.item.value == innerData.value) {
                    getIndex = index;
                }
            });
            if (getIndex >= 0) {
                $excludeDisp.splice(getIndex, 1);//splice the array to remove the object
                let tempExclude = $excludeDisp.map(a => a.value).toString()
                tempExclude = tempExclude ? tempExclude : "empty";
                $filterHandleChange({ 'exclude': tempExclude, clicked: 'exclude' });//pass to the final function
            }
        });
        jQuery('#include-taginput').on('itemRemoved', function (event) {
            var getIndex = -1;//getIndex of object
            $includeDisp.map(function (innerData, index) {//loop the array to find index
                if (event.item.value == innerData.value) {
                    getIndex = index;
                }
            });
            if (getIndex >= 0) {
                $includeDisp.splice(getIndex, 1);//splice the array to remove the object
                let tempInclude = $includeDisp.map(a => a.value).toString()
                tempInclude = tempInclude ? tempInclude : "empty";
                $filterHandleChange({ 'include': tempInclude, clicked: 'include' });//pass to the final function
                // if($current_page=="dashboard")
                //     $filterHandleChange($includeDisp);
                // else $filterHandleChange('include', $includeDisp);//pass to the final function
            }
        });
        jQuery('#metric-taginput').on('itemRemoved', function (event) {
            var getIndex = -1;//getIndex of object
            selectedMetricDisp.map(function (innerData, index) {//loop the array to find index
                if (event.item.value == innerData.value) {
                    getIndex = index;
                }
            });
            if (getIndex >= 0) {
                selectedMetricDisp.splice(getIndex, 1);//splice the array to remove the object

                var temp_metric = selectedMetricDisp.map(a => a.value).toString();
                temp_metric = temp_metric ? temp_metric : "empty";
                $filterHandleChange({ "selectedMetric": temp_metric, clicked: 'metric' })//pass to the final function
                // $handleChange('metric', selectedMetricDisp);
            }
        });
    }
    filterValuesToShow = (data, prevProps) => {
        this.tagsDefining();
        var metric_multi = this.state.metric_multi;
        // if((prevProps && data.period == 'Aggregate' && prevProps.period != data.period) || (data.propertyDisp && data.propertyDisp.type == 'propertyLabel'))
        //     metric_multi = false;
        this.setState({
            ...data,
            insightPoint: data.insightPoint,
            period: data.period,
            insightEnable: false,
            metric_multi: metric_multi,
            pageName: data.pageName
        })
        //if property multi then show tags
        // if (data.propMulti) {
        jQuery('#propertySelect>.bootstrap-tagsinput').show();//if tag feild is hidden so always enable when property is multi
        var elt = jQuery('#property-taginput');
        elt.tagsinput('removeAll');//remove all tags default
        if (data.propertyDisp) {//if properties exist then need to print
            if ((typeof data.propertyDisp == 'object')) {//if property array is object type
                if (data.propertyDisp.length) {//if property is object and has multiple array then iterate
                    data.propertyDisp.map(function (innerData) {
                        elt.tagsinput('add', innerData);
                    })
                }
                else elt.tagsinput('add', data.propertyDisp);
            } else {
                data.propertyDisp.map(function (innerData) {
                    elt.tagsinput('add', innerData);
                })
            }
        }
        // } else {
        //     //if property != multi then hide tags
        //     jQuery('#propertySelect>.bootstrap-tagsinput').hide();
        // }
        //filter tags
        var eltFilter = jQuery('#filter-taginput');
        eltFilter.tagsinput('removeAll');//remove all tags default
        if (data.SelectedBreakUpDisp) {//if properties exist then need to print
            if ((typeof data.SelectedBreakUpDisp == 'object')) {//if property array is object type
                if (data.SelectedBreakUpDisp.length) {//if property is object and has multiple array then iterate
                    data.SelectedBreakUpDisp.map(function (innerData) {
                        eltFilter.tagsinput('add', innerData);
                    })
                }
                else eltFilter.tagsinput('add', data.SelectedBreakUpDisp);
            } else {
                data.SelectedBreakUpDisp.map(function (innerData) {
                    eltFilter.tagsinput('add', innerData);
                })
            }
        }
        //Include tags
        var eltInclude = jQuery('#include-taginput');
        eltInclude.tagsinput('removeAll');//remove all tags default
        if (data.includeDisp) {//if properties exist then need to print
            if ((typeof data.includeDisp == 'object')) {//if property array is object type
                if (data.includeDisp.length) {//if property is object and has multiple array then iterate
                    data.includeDisp.map(function (innerData) {
                        eltInclude.tagsinput('add', innerData);
                    })
                }
                else eltInclude.tagsinput('add', data.includeDisp);
            } else {
                data.includeDisp.map(function (innerData) {
                    eltInclude.tagsinput('add', innerData);
                })
            }
        }
        //Exclude tags
        var eltExclude = jQuery('#exclude-taginput');
        eltExclude.tagsinput('removeAll');//remove all tags default
        if (data.excludeDisp) {//if properties exist then need to print
            if ((typeof data.excludeDisp == 'object')) {//if property array is object type
                if (data.excludeDisp.length) {//if property is object and has multiple array then iterate
                    data.excludeDisp.map(function (innerData) {
                        eltExclude.tagsinput('add', innerData);
                    })
                }
                else eltExclude.tagsinput('add', data.excludeDisp);
            } else {
                data.excludeDisp.map(function (innerData) {
                    eltExclude.tagsinput('add', innerData);
                })
            }
        }
        //metric tags
        var eltMetric = jQuery('#metric-taginput');
        eltMetric.tagsinput({
            itemValue: 'value',
            itemText: 'label',
            tagClass: function (item) {
                return (item.isDerived !== '2' ? 'label label-info contextAllow' : 'label label-info noContext');
            }
        });
        eltMetric.tagsinput('removeAll');//remove all tags default
        if (data.selectedMetricDisp) {//if properties exist then need to print
            if ((typeof data.selectedMetricDisp == 'object')) {//if property array is object type
                if (data.selectedMetricDisp.length) {//if property is object and has multiple array then iterate
                    data.selectedMetricDisp.map(function (innerData) {
                        if (typeof innerData == "object")
                            eltMetric.tagsinput('add', innerData);
                    })
                }
                else eltMetric.tagsinput('add', data.selectedMetricDisp);
            } else {
                data.selectedMetricDisp.map(function (innerData) {
                    eltMetric.tagsinput('add', innerData);
                })
            }
        }
    }
    selectLoad = (input, callback) => {
        asyncFilter(input, null, callback, this.props.authData);
    }
    selectIncludeLoad = (input, callback) => {
        asyncFilter(input, 'include_filter', callback, this.props.authData);
    }
    selectExcludeLoad = (input, callback) => {
        asyncFilter(input, 'exclude_filter', callback, this.props.authData);
    }
    changeChart(e, type) {
        if (e == 'time') {
            type = type.value;
            // Set transpose to false
            var tempStartDate = moment(this.state.startDate, "YYYY-MM-DD").format('YYYY-MM-DD');
            var tempEndDate = moment(this.state.endDate, "YYYY-MM-DD").format('YYYY-MM-DD');
            var dateDiff = moment(tempStartDate, 'YYYY-MM-DD').diff(moment(tempEndDate, 'YYYY-MM-DD'), 'days');
            if (type == "Day" && dateDiff < -365) {
                jQuery('.dateText').text(moment(this.state.startDate).format(dateFormatCalendar1) + ' - ' + moment(this.state.endDate).format(dateFormatCalendar2));
                alert("Day wise data can be viewed for one year only.");
                return null;
            }
            var transpose = type ? 'false' : this.state.transpose;
            metricGlobal = modifyMetricGlobal(metricGlobal, 'report', type);
            this.props.filterHandleChange({ "period": type, clicked: 'period' })
        } else if (e == 'outputType') {
            if(type.value=="transpose"){
                var transposeValue = this.props.transpose == true ? false : true
                var currentUrl = window.location.search + `&transpose=${transposeValue}`
                var urlObj = Object.fromEntries(new URLSearchParams(currentUrl));         
                updateURL(urlObj, '', false) 
                this.props.handle_transpose_table({ transpose: transposeValue })
            }
            else if(type.value=="crosstab"){
                // let transposeValue = this.props.crosstab_flag == true ? false : true
                var currentUrlParams = window.location.search + `&multiDim=false`
                var urlObj = Object.fromEntries(new URLSearchParams(currentUrlParams));         
                updateURL(urlObj, '', true) 
                this.props.setTableActions({ crosstab_flag: false })
            }else {
                // let transposeValue = this.props.crosstab_flag == true ? false : true
                var currentUrlParams = window.location.search + `&multiDim=true&transpose=false`
                var urlObj = Object.fromEntries(new URLSearchParams(currentUrlParams));         
                updateURL(urlObj, '', true) 
                this.props.setTableActions({ crosstab_flag: true , transpose: false })
            }
        }
    }
    selectPropLoad = (input, callback) => {
        let chartCat = getParametersFromString('chartCat', location.search)
        chartCat = chartCat && chartCat == 'Map' ? "locationColumns" : (this.state.pageName == "dashboard" ? "propertyLabel" : "propLabel");

        asyncFilter(input, chartCat, callback, this.props.authData);
    }
    closeClusterInsight = () => {
        var width = jQuery('#SidebarInsightDiv').width();
        if (width)
            closeSidebar('SidebarInsightDiv');
        closeSidebar('FilterDiv');
        this.props.removeFilter();
        jQuery("#main-content").css("marginRight", "0px");
        var url = document.location.pathname;
        if (url == '/dashboard/charttype' && highChartsDiv) {
            highChartsDiv.reflow();
        }
        if (url == '/dashboard/dashboard' && highChartsDiv) {
            dragcomplete();
        }
    }
    toggleLabels = () => {
        var sampleChart = highChartsDiv;
        var dataLabel = jQuery('#dataLabels').html();
        if (dataLabel == "Add Data Labels") {
            this.setState({
                dataLabelsButton: "Remove Data Labels"
            });
            // jQuery('#dataLabels').html("Remove Data Labels");
        }
        else {
            this.setState({
                dataLabelsButton: "Add Data Labels"
            });
            // jQuery('#dataLabels').html("Add Data Labels");
        }
        // var optMain = sampleChart.series;
        // if(optMain.length>1){
        //     for (var i = 0; i < optMain.length; i++) {
        //         optMain[i].options.dataLabels.enabled = !optMain[i].options.dataLabels.enabled;
        //     }
        //     sampleChart.update(optMain);
        // }else {
        for (var i = 0; i < sampleChart.series.length; i++) {
            var opt = sampleChart.series[i].options;
            opt.dataLabels.enabled = !opt.dataLabels.enabled;
            sampleChart.series[i].update(opt);
        }
        // }
    }
    propertyHandle = (e, type) => {
        if (jQuery(window).width() <= mobile_width) {
            this.closeClusterInsight();
        }
        var arrayData = this.props.propertyDisp;
        if (typeof type == "object") {
            if (!propMulti) {
                arrayData = [];
            }
            if (type.length) {                    
                arrayData = arrayData[0]['value'] == 'all' ? [] : arrayData
                arrayData.push(type[0]);
            }                
            else {
                // This is to handle the case when dimension is changed from up, down toggle 
                arrayData = []
                arrayData.push(type);  
            } 
        } else
            arrayData.push(type);
        
        var crosstabObj = {};
        // if(this.props.pageName=="report" && arrayData.length==2){
        //     crosstabObj = {
        //         crosstab_flag: "false",
        //         transpose: "false"
        //     }
        // }else {
            crosstabObj = {
                crosstab_flag: "true",
                transpose: "false"
            }
        // }

        this.props.filterHandleChange({ ...crosstabObj , "selectedMetric": this.props.selectedMetric, "property": arrayData.map(a => a.value).toString(), "breakup": this.props.breakup, "period": this.state.period, clicked: 'property' })
    }
    filterHandle = (e, type) => {
        let temp_variable = null;
        let refresh_variable = null;
        var breakup = this.state.breakup, include = this.state.include, exclude = this.state.exclude, input = '';
        switch (e) {
            case 'breakup':
                temp_variable = this.props.SelectedBreakUpDisp;
                refresh_variable = this.refs.breakupFilter;
                breakup = this.arrayData(this.props.SelectedBreakUpDisp, type);
                break;
            case 'include':
                temp_variable = this.props.includeDisp;
                refresh_variable = this.refs.breakupInclude;
                include = this.arrayData(this.props.includeDisp, type);
                break;
            case 'exclude':
                temp_variable = this.props.excludeDisp;
                refresh_variable = this.refs.breakupExclude;
                exclude = this.arrayData(this.props.excludeDisp, type);
                break;
        }

        this.props.filterHandleChange({ "selectedMetric": this.props.selectedMetric, "property": this.props.property, "breakup": breakup, "period": this.state.period, include: include, exclude: exclude, clicked: 'filter' })
    }
    arrayData(arrayData, type) {
        arrayData = arrayData ? arrayData : [];
        var check = checkInArray(arrayData, type[0]);
        if (!check) {
            if (typeof type == "object") {
                if (type.length)
                    arrayData.push(type[0]);
                else arrayData.push(type);
            } else {
                arrayData.push(type);
            }
        }
        return arrayData.map(a => a.value).toString();
    }
    metricHandle = (e, type, callback) => {
        var arrayData = [], input = '', check = false;
        // asyncFilter(input, 'propLabel', callback);
        if (type[0])
            type = type[0];
        type = addDefaultFunction(type, Object.values($metricFunction), type.defaultFormula);
        arrayData = this.props.selectedMetricDisp ? this.props.selectedMetricDisp : [];
        check = checkInArray(arrayData, type);
        if (!check) {
            if (typeof type == "object") {
                if (metricMulti) {
                    arrayData.push(type);
                } else {
                    arrayData = [];
                    arrayData.push(type);
                }
            }
            selectedMetricDisp = arrayData;
            this.props.filterHandleChange({ "selectedMetric": arrayData.map(a => a.value).toString(), "property": this.props.property, "breakup": this.props.breakup, "period": this.state.period, clicked: 'metric' })
        }
    }
    closeSidebarAndOpenFilter = (action) => {
        var width = jQuery('#SidebarInsightDiv').width();
        if (width)
            closeSidebar('SidebarInsightDiv');
        if (action == 'close') {
            closeSidebar('FilterDiv');
            jQuery("#main-content").css("marginRight", "0px");
        } else {
            var width = jQuery('#FilterDiv').width();
            if (width <= 0) {
                if (jQuery(window).width() >= mobile_width) {
                    openSidebar('FilterDiv', filter_desktop_width);
                    jQuery("#main-content").css("marginRight", main_content_div_filter);
                } else openSidebar('FilterDiv', filter_mobile_width);
            }
        }
        var url = document.location.pathname;
        if (url == '/dashboard/dashboard' && highChartsDiv) {
            highChartsDiv.map(function (innerData, index) {
                highChartsDiv[index].reflow();
            })
        }
    }
    openSidebarInsight = () => {
        this.props.enablePageDescription(true);
        this.setState({ insightEnable: true, insightPoint: null, period: null });
        closeSidebar('FilterDiv');
        // if ((document.getElementById('SidebarInsightDiv') && !document.getElementById('SidebarInsightDiv').style.width) || document.getElementById('SidebarInsightDiv').style.width == '0px')
        //     openSidebar('SidebarInsightDiv', "360px");
    }
    handleInsightEnable = (param) => {
        this.setState({ insightEnable: param });
    }
    handleSaveReportClick = () => {
        jQuery('#saveReportPopup').modal('toggle');
    }
    switchButton = () => {
        jQuery('.chartsHide').toggle();
    }
    property_multi_enable = (e) => {

        let buttonClicked = jQuery(e.target).attr('id').split('-')[0];
        let property_multi_flag = this.state.property_multi;
        let crosstab_flag = this.state.crosstab_flag;
        if (buttonClicked == 'crosstab') {   // Handle Crosstab button clicked
            var enable_crosstab_title = this.state.enable_crosstab_title;
            if (crosstab_flag) {
                document.getElementById('crosstab-enabled').style.color = "#49bf67";
                enable_crosstab_title = 'Disable Crosstab';
            } else {
                document.getElementById('crosstab-enabled').style.color = "black";
                enable_crosstab_title = 'Enable Crosstab';
            }
            crosstab_flag = !crosstab_flag;
            // this.props.chartCat == 'report' ? this.props.handleCrosstabEnable(property_multi_flag) : '';
        } else {    // Handle Multi dimension clicked
            var enable_multi_dimension_title = this.state.enable_multi_dimension_title;
            if (!property_multi_flag) {
                document.getElementById('multi-property-enabled').style.color = "#49bf67";
                enable_multi_dimension_title = 'Disable Multiple Dimensions';
            } else {
                document.getElementById('multi-property-enabled').style.color = "black";
                enable_multi_dimension_title = 'Enable Multiple Dimensions';
            }
            // this.props.chartCat == 'report' ? this.props.handleCrosstabEnable(property_multi_flag) : '';
            property_multi_flag = !property_multi_flag;
        }

        let updateParams = {}
        updateParams.property = this.props.property;
        updateParams.metric = this.props.selectedMetric
        updateParams.breakup = this.props.breakup
        updateParams.startDate = this.props.startDate
        updateParams.endDate = this.props.endDate
        updateParams.chartCat = this.props.chartCat
        updateParams.limit = this.props.limit
        updateParams.sortOrder = this.props.sortOrder
        updateParams.period = this.props.period
        updateParams.include = this.props.include
        updateParams.exclude = this.props.exclude
        updateParams.crosstab_flag = crosstab_flag.toString();

        updateURL(updateParams);

        this.props.setTableActions({ propMulti: property_multi_flag, crosstab_flag: crosstab_flag, enable_multi_dimension_title: enable_multi_dimension_title, enable_crosstab_title: enable_crosstab_title })
    }
    metric_multi_enable = () => {
        if (!this.state.metric_multi) {
            document.getElementById('metric-multi-enabled').style.color = "#49bf67";
        } else document.getElementById('metric-multi-enabled').style.color = "black";
        this.setState({
            metric_multi: !this.state.metric_multi
        })
    }
    handle_next_before = (type) => {
        var data_to_set = {};
        if (type == "down") {            
            property_current_index = !refineURLData(getParameters('property')) ? 1 : property_current_index + 1;
            property_current_index = property_current_index >= property_filter.length ? 0 : property_current_index;
            property_current_index = parseInt(property_current_index);
        }
        else {            
            property_current_index = !refineURLData(getParameters('property')) ? -1 : property_current_index - 1;
            property_current_index = property_current_index < 0 ? (property_filter.length - 1) : property_current_index;
        }
        data_to_set = property_filter[property_current_index];
        propertyMain = data_to_set.value;
        this.propertyHandle('property', data_to_set, null)
    }
    key_handle_function = (e) => {
        var arrow = { left: 37, up: 38, right: 39, down: 40 };
        switch (e.keyCode) {
            case arrow.left:
                break;
            case arrow.up:
                this.handle_next_before("up");
                break;
            case arrow.down:
                this.handle_next_before("down");
                break;
            case arrow.right:
                break;
        }
    }
    oldFilterToggle = () =>{
        this.props.toggleOldFilter();
    }
    render() {
        var that = this;
        if (jQuery(window).width() < filter_mobile_width) {
            var filterDivWidth = { paddingTop: '0px', width: "100%", paddingBottom: "200px", position: "absolute", zIndex: '1001' };
        } else var filterDivWidth = { width: "387px" };

        var chartCatVar = this.props.pageName=="summary" ? "Block" : this.props.pageName=="report" ? "Table" : this.props.chartCat;
        // filter conditions
        var filterConditions = this.props.selectedMetric && this.props.pageName!="pinboard" ? validationInput(this.props.property, this.props.selectedMetric, this.props.period ? this.props.period : "", chartCatVar.toLowerCase(), "all") : {};

        // Property case handled
        var up_down_buttons = <span>{"  "}<i className="fa fa-caret-up" id="property_top" style={{ marginLeft: '10px' }} onClick={this.handle_next_before.bind(this, "up")}></i>{"  "}<i className="fa fa-caret-down" id="property_down" onClick={this.handle_next_before.bind(this, 'down')} style={{ marginLeft: '5px' }}></i></span>;
        // var multiProperty = filterConditions.filter && filterConditions.filter.propertyMulti == "true" ? <i id="multi-property-enabled" className="float-right fa fa-plus-circle" onClick={this.property_multi_enable.bind(this)} style={{ cursor: 'pointer' }}></i> : null;
        var multiProperty = filterConditions.filter && filterConditions.filter.propertyMulti == "true" ? <span>{" (You can select multiple)"}</span> : null;
        // var crossTabButton = <i id="crosstab-enabled" className="fa fa-plus-circle" onClick={this.property_multi_enable.bind(this)} style={{ cursor: 'pointer', marginLeft: '2%' }}></i>
        var crossTabButton = null
        propMulti = filterConditions.filter && filterConditions.filter.propertyMulti == "true" ? true : false;

        var property_compare = <p className="select_header">Choose Dimensions{up_down_buttons}{multiProperty}{crossTabButton}</p>;

        // Metric case handled
        // var multiMetricOptions = filterConditions.filter && filterConditions.filter.metricMulti == "true" ? <i id="multi-property-enabled" className="float-right fa fa-plus-circle" onClick={this.property_multi_enable.bind(this)} style={{ cursor: 'pointer' }}></i> : null;
        var multiMetricOptions = filterConditions.filter && filterConditions.filter.metricMulti == "true" ? <span>{" (You can select multiple)"}</span> : null;
        metricMulti = filterConditions.filter && filterConditions.filter.metricMulti == "true" ? true : false;

        let metricOptions = []
        this.props.Metric.map(function(innerData){
            if(innerData.isDisplay && innerData.isDisplay=="1")
                metricOptions.push(innerData);
        });

        var metricData = <div className='col-md-12' id="metricSelect" style={textMarginTop}>
            <p className=''>Metric{multiMetricOptions}</p>
            <input type="text" id="metric-taginput" />
            <Select placeholder="Select Metric"
                name="metricValue"
                value={null}
                onChange={this.metricHandle.bind(this, 'metric')}
                options={metricOptions}
                style={textMarginBottom}
                isMulti={metricMulti}
            />
        </div>;
        
        let tempGranValue = this.props.TimeType.filter(function(innerData){ return innerData.value == that.props.period})
        var timeGranularity = filterConditions.filter && filterConditions.filter.time == "true" ? <div className='col-md-12' id="timeGranSelect" style={textMarginTop}>
            <p className=''>Time Granularity</p>
            <Select simpleValue placeholder="Time Granularity"
                name="timeGranularity"
                value={tempGranValue}
                onChange={this.changeChart.bind(this, 'time')}
                options={this.props.TimeType}
                clearable={false}
                style={textMarginBottom}
            />
        </div> : null;
        
        let outputTypeObj = this.props.transpose == "true" || this.props.transpose == true ? "transpose" : (this.props.crosstab_flag === "false" || this.props.crosstab_flag === false ? "crosstab" : "normal");
        var outputTypeValue = filterConditions.filter && filterConditions.filter.outputType ? filterConditions.filter.outputType.filter(function (innerData) { return innerData.value == outputTypeObj }) : null;
        var outputTypeVar = filterConditions.filter && filterConditions.filter.outputType ? <div className='col-md-12' id="outputTypeSelect" style={textMarginTop}>
            <p className=''>Output Type</p>
            <Select simpleValue placeholder="Transpose"
                name="transpose"
                value={outputTypeValue}
                onChange={this.changeChart.bind(this, 'outputType')}
                options={filterConditions.filter.outputType}
                clearable={false}
                style={textMarginBottom}
            />
        </div> : null;

        return (
            <div className="pd-t-0">
                <div className='sidebar sidebar-fixed insight-formatting' id='FilterDiv' style={filterDivWidth}>
                    <div className="card-header tx-16 pd-10">
                        <div style={{ overflow: "auto" }}>
                            Filter Settings
                            {/* <div className="d-inline-flex mg-b-0 form-group custom-control custom-switch mg-l-100">
                                <input type="checkbox" className="custom-control-input" id="dateView" checked={this.state.oldFilter} onChange={this.oldFilterToggle}/>
                                <label className="custom-control-label tx-13" for="dateView">Old Filter</label>
                            </div> */}
                            <a href="javascript:void(0)" className="close float-right" onClick={this.closeClusterInsight}>&times;</a>
                        </div>
                    </div>
                    <div className="insight-overflow">
                        <div className="col-12 pd-t-15">
                            <div style={{ height: "39px" }}>
                                <CalenderComponent startDate={this.props.startDate} endDate={this.props.endDate} startDateDisp={this.props.startDateDisp} endDateDisp={this.props.endDateDisp} page={this.props.chartCat} datasetDetails={this.props.datasetDetails} granularity={this.props.granularity} dashboardConfigDates={this.props.dashboardConfigDates} pageName={this.props.pageName} />
                            </div>
                        </div>
                        <div className='col-md-12' id="propertySelect" style={{ marginTop: '15px' }}>
                            {property_compare}
                            <input type="text" id="property-taginput" />
                            <AsyncSelect placeholder="Select Dimensions (Type to search)"
                                name="property"
                                ref="propertyFilter"
                                value={null}
                                defaultOptions={true}
                                onChange={this.propertyHandle.bind(this, 'property')}
                                loadOptions={this.selectPropLoad}
                                isMulti={propMulti}
                                style={textMarginBottom}
                                cache={false}
                            />
                        </div>
                        {metricData}
                        {outputTypeVar}
                        {timeGranularity}
                        <div className='col-md-12' id="filterSelect" style={textMarginTop}>
                            <p className="select_header">Filter by</p>
                            <input type="text" id="filter-taginput" />
                            <AsyncSelect placeholder="Filter by (Type to search)"
                                name="SelectedBreakUp"
                                ref="breakupFilter"
                                value={null}
                                onChange={this.filterHandle.bind(this, 'breakup')}
                                defaultOptions={true}
                                isMulti
                                loadOptions={this.selectLoad}
                                style={textMarginBottom}
                                cacheOptions={true}
                            />
                        </div>
                        <div className='col-md-12' id="includeSelect" style={textMarginTop}>
                            <p className="select_header">Include</p>
                            <input type="text" id="include-taginput" />
                            <AsyncSelect placeholder="For Include (Type to search)"
                                name="include"
                                ref="breakupInclude"
                                value={null}
                                onChange={this.filterHandle.bind(this, 'include')}
                                defaultOptions={true}
                                isMulti
                                loadOptions={this.selectIncludeLoad}
                                style={textMarginBottom}
                                cacheOptions={false}
                            />
                        </div>
                        <div className='col-md-12' id="excludeSelect" style={textMarginTop}>
                            <p className="select_header">Exclude</p>
                            <input type="text" id="exclude-taginput" />
                            <AsyncSelect placeholder="For Exclude (Type to search)"
                                name="exclude"
                                ref="breakupExclude"
                                value={null}
                                onChange={this.filterHandle.bind(this, 'exclude')}
                                defaultOptions={true}
                                isMulti
                                loadOptions={this.selectExcludeLoad}
                                style={textMarginBottom}
                                cacheOptions={false}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        filter: state.dataSet.filter,
        granularity: state.dataSet.summarizationDetails[0].granularity,
        dashboardConfigDates: state.dataSet.dashboard,
        oldFilter: state.dataSet.oldFilter || false
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        removeFilter, set_property_metric_breakup, remove_property_metric_breakup, get_property_metric_breakup, set_disp_objects, setTableActions, handle_transpose_table, toggleOldFilter
    }, dispatch)
}
function checkInArray(array, newData) {
    var check = false;
    array.map(function (innerData, index) {
        if (innerData.value == newData.value)
            check = true;
    })
    return check;
}
export default connect(mapStateToProps, mapDispatchToProps)(FilterComponent)

